<template>
  <div data-private class="h-screen flex flex-col bg-gray-50">
    <!-- Breadcrumb header -->
    <div class="shrink-0 bg-white border-b border-gray-200 px-6 py-3 flex items-center justify-between">
      <div class="flex items-center gap-2 text-sm">
        <router-link to="/caremanagement/patients" class="text-gray-500 hover:text-gray-700">
          Care Management
        </router-link>
        <span class="text-gray-300">/</span>
        <span class="sensitive text-gray-900 font-medium" :data-spoof-kind="patientName ? 'person' : 'identifier'">{{ patientName || patientIdentifier }}</span>
        <span v-if="patientDob" class="text-gray-400">·</span>
        <span v-if="patientDob" class="text-gray-500">DOB <span class="sensitive" data-spoof-kind="dob">{{ patientDob }}</span></span>
        <span v-if="patientName" class="text-gray-400">·</span>
        <span v-if="patientName" class="sensitive text-gray-500" data-spoof-kind="identifier">{{ patientIdentifier }}</span>
      </div>
    </div>

    <!-- Full-screen drawer -->
    <div class="flex-1 overflow-hidden">
      <Patient_Drawer
        :patient-identifier="patientIdentifier"
        :entity-id="entityIdNum"
        :patient-data="fetchedPatientData"
        :enabled-tabs="enabledTabs"
        :show-header="false"
        :default-tab="defaultTab"
        metric-category="Care Management"
      />
    </div>
  </div>
</template>

<script>
import Patient_Drawer from './Patient_Drawer.vue';
import axios from 'axios';

export default {
  name: 'Patient_Drawer_Page',
  components: { Patient_Drawer },
  props: {
    patientIdentifier: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      fetchedPatientData: null,
      enabledTabs: [
        'details', 'utilization', 'programs', 'engagement',
        'care_plan', 'care_graph', 'gaps', 'care_team', 'hcc_history',
        'coding_activity', 'suspects', 'insights', 'messages'
      ],
    };
  },
  computed: {
    entityIdNum() {
      const eid = this.$route.query.entity;
      return eid ? parseInt(eid) : null;
    },
    defaultTab() {
      return this.$route.query.tab || 'details';
    },
    patientName() {
      const d = this.fetchedPatientData;
      if (!d) return '';
      const first = d.bene_first_name || '';
      const last = d.bene_last_name || '';
      return `${first} ${last}`.trim();
    },
    patientDob() {
      const raw = this.fetchedPatientData?.bene_dob || this.fetchedPatientData?.patient_dob;
      if (!raw) return '';
      const parts = String(raw).substring(0, 10).split('-');
      if (parts.length !== 3) return '';
      const d = new Date(parts[0], parts[1] - 1, parts[2]);
      if (isNaN(d.getTime())) return '';
      return d.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });
    },
  },
  methods: {
    // Demo Mode: dates tagged data-spoof-kind="date" inside this record
    // share one offset (an opaque key; nothing is bound outside Demo Mode).
    },
  async mounted() {
    try {
      const { data } = await axios.post('api/returnpatientdata/', {
        data_type: 'patient_info',
        patient_identifier: this.patientIdentifier,
      });
      if (data?.length) {
        this.fetchedPatientData = data.reduce((acc, curr) => {
          Object.keys(curr).forEach((key) => {
            if (curr[key] !== null && curr[key] !== undefined && acc[key] === undefined) {
              acc[key] = curr[key];
            }
          });
          return acc;
        }, {});
      }
    } catch {
      // Drawer tabs self-fetch; name is cosmetic
    }
  },
};
</script>
